export enum USState {
  AL = "AL",
  AK = "AK",
  AZ = "AZ",
  AR = "AR",
  CA = "CA",
  CO = "CO",
  CT = "CT",
  DE = "DE",
  FL = "FL",
  GA = "GA",
  HI = "HI",
  ID = "ID",
  IL = "IL",
  IN = "IN",
  IA = "IA",
  KS = "KS",
  KY = "KY",
  LA = "LA",
  ME = "ME",
  MD = "MD",
  MA = "MA",
  MI = "MI",
  MN = "MN",
  MS = "MS",
  MO = "MO",
  MT = "MT",
  NE = "NE",
  NV = "NV",
  NH = "NH",
  NJ = "NJ",
  NM = "NM",
  NY = "NY",
  NC = "NC",
  ND = "ND",
  OH = "OH",
  OK = "OK",
  OR = "OR",
  PA = "PA",
  RI = "RI",
  SC = "SC",
  SD = "SD",
  TN = "TN",
  TX = "TX",
  UT = "UT",
  VT = "VT",
  VA = "VA",
  WA = "WA",
  WV = "WV",
  WI = "WI",
  WY = "WY",
  DC = "DC",
  AS = "AS",
  GU = "GU",
  MP = "MP",
  PR = "PR",
  VI = "VI",
}

export const STATE_NAMES: Record<USState, string> = {
  [USState.AL]: "Alabama",
  [USState.AK]: "Alaska",
  [USState.AZ]: "Arizona",
  [USState.AR]: "Arkansas",
  [USState.CA]: "California",
  [USState.CO]: "Colorado",
  [USState.CT]: "Connecticut",
  [USState.DE]: "Delaware",
  [USState.FL]: "Florida",
  [USState.GA]: "Georgia",
  [USState.HI]: "Hawaii",
  [USState.ID]: "Idaho",
  [USState.IL]: "Illinois",
  [USState.IN]: "Indiana",
  [USState.IA]: "Iowa",
  [USState.KS]: "Kansas",
  [USState.KY]: "Kentucky",
  [USState.LA]: "Louisiana",
  [USState.ME]: "Maine",
  [USState.MD]: "Maryland",
  [USState.MA]: "Massachusetts",
  [USState.MI]: "Michigan",
  [USState.MN]: "Minnesota",
  [USState.MS]: "Mississippi",
  [USState.MO]: "Missouri",
  [USState.MT]: "Montana",
  [USState.NE]: "Nebraska",
  [USState.NV]: "Nevada",
  [USState.NH]: "New Hampshire",
  [USState.NJ]: "New Jersey",
  [USState.NM]: "New Mexico",
  [USState.NY]: "New York",
  [USState.NC]: "North Carolina",
  [USState.ND]: "North Dakota",
  [USState.OH]: "Ohio",
  [USState.OK]: "Oklahoma",
  [USState.OR]: "Oregon",
  [USState.PA]: "Pennsylvania",
  [USState.RI]: "Rhode Island",
  [USState.SC]: "South Carolina",
  [USState.SD]: "South Dakota",
  [USState.TN]: "Tennessee",
  [USState.TX]: "Texas",
  [USState.UT]: "Utah",
  [USState.VT]: "Vermont",
  [USState.VA]: "Virginia",
  [USState.WA]: "Washington",
  [USState.WV]: "West Virginia",
  [USState.WI]: "Wisconsin",
  [USState.WY]: "Wyoming",
  [USState.DC]: "District of Columbia",
  [USState.AS]: "American Samoa",
  [USState.GU]: "Guam",
  [USState.MP]: "Northern Mariana Islands",
  [USState.PR]: "Puerto Rico",
  [USState.VI]: "U.S. Virgin Islands",
};

export const stateOptions = Object.entries(STATE_NAMES).map(([value, label]) => ({
  value,
  label: `${value} - ${label}`,
}));

/**
 * Validates a state input and returns the two-letter abbreviation
 * @param input - String or null representing a state
 * @returns USState enum value or null if invalid
 */
export function validateState(input: string | null): USState | null {
  if (!input) return null;

  const normalized = input.trim().toUpperCase();

  // Direct match for two-letter codes
  if (normalized in USState) {
    return normalized as USState;
  }

  // Match by full state name (case-insensitive)
  const stateEntry = Object.entries(STATE_NAMES).find(([_, name]) => name.toLowerCase() === normalized.toLowerCase());

  return stateEntry ? (stateEntry[0] as USState) : null;
}
